/**
 * Feature-flag slugs we use to gate services, HTTP endpoints, and related
 * capabilities (print, GPS, payment integrations, and so on).
 *
 * Each value is the catalog slug. On the metering provider the matching custom
 * field is `ff_<slug>`, so a commercial grant can flow through to the runtime
 * check (`TenantFeaturePolicy` / `@RequireFeature`).
 */
export enum TenantFeatureFlagEnum {
  RENTAL_AGREEMENTS = 'rental-agreements',
  E_SIGNATURES = 'e-signatures',
  RENTAL_RESERVATIONS = 'rental-reservations',
  VEHICLES = 'vehicles',
  CUSTOMERS = 'customers',
  LOCATIONS = 'locations',
  PAYMENTS = 'payments',
  TRANSACTIONS = 'transactions',
  AGENTS = 'agents',
  SUPPLIERS = 'suppliers',
  POLICIES = 'policies',
  VEHICLE_DAMAGES = 'vehicle-damages',
  VEHICLE_MAINTENANCES = 'vehicle-maintenances',
  VEHICLE_INSURANCES = 'vehicle-insurances',
  VEHICLE_ROAD_TAXES = 'vehicle-road-taxes',
  VEHICLE_ROAD_WORTHY_CHECKS = 'vehicle-road-worthy-checks',
  GPS_TRACKING = 'gps-tracking',
  PDF_PRINTING = 'pdf-printing',
}
